import { render, staticRenderFns } from "./pc-leg-iab-stack-block.vue?vue&type=template&id=3fc262d2&"
import script from "./pc-leg-iab-stack-block.vue?vue&type=script&lang=js&"
export * from "./pc-leg-iab-stack-block.vue?vue&type=script&lang=js&"
import style0 from "./pc-leg-iab-stack-block.vue?vue&type=style&index=0&id=3fc262d2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports